import { render, staticRenderFns } from "./materials_details.vue?vue&type=template&id=76b7342e&scoped=true&"
import script from "./materials_details.vue?vue&type=script&lang=js&"
export * from "./materials_details.vue?vue&type=script&lang=js&"
import style0 from "./materials_details.vue?vue&type=style&index=0&id=76b7342e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b7342e",
  null
  
)

export default component.exports